import React from "react";

export default function Disclaimer() {
  return (
    <div className="w-full">
      {/* Hero Banner */}
      <div
        className="relative h-[300px] md:h-[400px] w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage:
            "url('/images/disclaimer.webp')", // Add a banner image inside /public/images/
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h1 className="relative text-4xl md:text-5xl font-bold text-white text-center">
          Disclaimer
        </h1>
      </div>
    <div className="max-w-5xl mx-auto px-6 py-12 bg-white rounded-xl shadow-md">
      
      {/* Title */}
      <h1 className="text-4xl font-bold text-gray-900 mb-6">Disclaimer</h1>

      {/* Intro */}
      <p className="text-gray-700 leading-relaxed mb-6">
        <strong>MAC LABS LIMITED</strong> (“Company,” “we,” “our,” or “us”)
        maintains this website to provide general information about our company,
        products, research, and services. By accessing and using this website,
        you agree to the terms of this disclaimer.
      </p>

      {/* Sections */}
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Not Medical Advice</h2>
          <p>
            The content on this website is for informational purposes only and
            should not be construed as medical advice, diagnosis, or treatment.
            Always seek the advice of a qualified healthcare professional
            regarding any medical condition or treatment.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-900">Regulatory Status</h2>
          <p>
            Information about our Active Pharmaceutical Ingredients (APIs),
            intermediates, and formulations is intended for business,
            regulatory, and professional stakeholders only. Our products are
            manufactured and supplied in accordance with applicable
            pharmaceutical regulations. Availability of products may depend on
            country-specific laws and approvals.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-900">Accuracy of Information</h2>
          <p>
            While we make every effort to ensure accuracy, completeness, and
            reliability, we do not guarantee that all information provided on
            this website is error-free or up to date. We assume no liability for
            any reliance placed on the materials presented.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-900">Third-Party Links</h2>
          <p>
            This website may contain external links. We are not responsible for
            the content, security, or practices of such third-party websites.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-900">Limitation of Liability</h2>
          <p>
            In no event shall <strong>MAC LABS LIMITED</strong>, its directors,
            employees, or associates be liable for any direct, indirect,
            incidental, consequential, or punitive damages arising from use of
            this website.
          </p>
        </div>
      </div>

      {/* Effective Date */}
      <p className="mt-8 text-gray-600 text-sm">
        <strong>Effective Date:</strong> 15-08-2025
      </p>
    </div>
    </div>
  );
}
